export default __webpack_public_path__ + "static/media/CRM-image.82f39415.png";